import React from 'react';
import { Dropdown, Menu } from 'semantic-ui-react';
import styled from 'styled-components';

import IconButton from '../../../components/IconButton';

import { CommissioningCollaborator } from '../types';

type Props = {
  collaborator: CommissioningCollaborator;
  canManage: boolean;
  isOwnCollaborator: boolean;
  onEdit: (collaborator: CommissioningCollaborator) => void;
  onEditBankAccount?: (collaborator: CommissioningCollaborator) => void;
  onRegisterBiometry: (collaborator: CommissioningCollaborator) => void;
  onDelete: (collaborator: CommissioningCollaborator) => void;
};

const ActionsDropdownMenu = styled(Dropdown.Menu)`
  &&& {
    min-width: 190px;
    width: 190px;
    z-index: 9999;
  }
`;

const CommissioningActionsMenu: React.FC<Props> = ({
  collaborator,
  canManage,
  isOwnCollaborator,
  onEdit,
  onEditBankAccount,
  onRegisterBiometry,
  onDelete
}) => {
  const showBiometryAction = collaborator.status === 'AWAITING_BIOMETRY';
  const showRetryBiometryAction = collaborator.status === 'BIOMETRY_REJECTED';
  const showEditRegistration =
    collaborator.status !== 'ACTIVE' && collaborator.status !== 'INACTIVE';
  const showEditBankAccount = collaborator.status === 'ACTIVE';
  const canOpenActions = canManage || isOwnCollaborator;

  return (
    <Menu compact>
      <Menu.Item>
        <Dropdown
          trigger={<IconButton name="ellipsis vertical" />}
          icon={null}
          direction="left"
          disabled={!canOpenActions}
        >
          <ActionsDropdownMenu>
            {showEditRegistration && (
              <Dropdown.Item
                icon="pencil alternate"
                text={
                  collaborator.status === 'AWAITING_BIOMETRY'
                    ? 'Visualizar/editar cadastro'
                    : 'Editar cadastro'
                }
                disabled={!canManage}
                onClick={() => {
                  if (canManage) onEdit(collaborator);
                }}
              />
            )}
            {showEditBankAccount && onEditBankAccount && (
              <Dropdown.Item
                icon="university"
                text="Alterar conta bancária"
                disabled={!canManage}
                onClick={() => {
                  if (canManage) onEditBankAccount(collaborator);
                }}
              />
            )}
            {showBiometryAction && (
              <Dropdown.Item
                icon="id card"
                text="Cadastrar biometria"
                disabled={!canOpenActions}
                onClick={() => {
                  if (canOpenActions) onRegisterBiometry(collaborator);
                }}
              />
            )}
            {showRetryBiometryAction && (
              <Dropdown.Item
                icon="redo"
                text="Tentar biometria novamente"
                disabled={!canOpenActions}
                onClick={() => {
                  if (canOpenActions) onRegisterBiometry(collaborator);
                }}
              />
            )}
            <Dropdown.Item
              icon="trash alternate"
              text="Remover"
              disabled={!canManage}
              onClick={() => {
                if (canManage) onDelete(collaborator);
              }}
            />
          </ActionsDropdownMenu>
        </Dropdown>
      </Menu.Item>
    </Menu>
  );
};

export default CommissioningActionsMenu;
